import { Component } from "@angular/core";


@Component({
    selector: "app-cp-00-90-07-88",
    standalone: true,
    templateUrl: "./cp-00-90-07-88.component.html",
    styleUrls: ["./cp-00-90-07-88.component.scss"],
})
export class CP00900788Component {
    
}